import { OPEN_GIF_MODAL, CLOSE_GIF_MODAL } from './actionTypes';

export const openGifModalAction = ({ onSelect }) => ({
  type: OPEN_GIF_MODAL,
  onSelect,
});

export const closeGifModalAction = () => ({
  type: CLOSE_GIF_MODAL,
});
